import React, { useState, useRef } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { IoArrowBack } from "react-icons/io5";
import { Link } from "react-router-dom";
import { updateBulkOrder } from "../../Services/orderService";
import toast from "react-hot-toast";

const BulkUpdate = () => {

    const [orderId, setOrderId] = useState("");
    const [orders, setOrders] = useState([]);
    const [bulkStatus, setBulkStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const handleAddOrder = () => {
        const trimmed = orderId.trim();
        if (!trimmed) return;

        if (orders.includes(trimmed)) {
            toast.warning("Order already added");
            return;
        }

        setOrders(prev => [...prev, trimmed]);
        setOrderId("");
        inputRef.current.focus();
    };

    const handleRemove = (id) => {
        setOrders(prev => prev.filter(o => o !== id));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddOrder();
        }
    };

    const handleBulkUpdate = async () => {

        if (!bulkStatus) {
            toast.warning("Please select status");
            return;
        }

        if (!orders.length) {
            toast.warning("No orders added");
            return;
        }

        try {
            setLoading(true);

            const body = {
                trackingId: orders,
                status: bulkStatus
            };

            const response = await updateBulkOrder(body);

            console.log("API Response:", response);

            if (response?.success) {

                toast.success(
                    `${response.updatedCount} order(s) processed successfully`
                );

                setOrders([]);
                setBulkStatus("");

            } else {
                toast.error(response?.message || "Something went wrong");
            }

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Server error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">

            <h4 className="mb-3">
                <Link to={"/portal/update-orders"} className="text-dark">
                    <IoArrowBack size={22} className="me-2" />
                </Link>
                Bulk Status Update
            </h4>

            <Form.Group className="mb-3 d-flex gap-2">
                <Form.Control
                    type="text"
                    value={orderId}
                    ref={inputRef}
                    onChange={(e) => setOrderId(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Scan / Enter Order ID"
                    autoFocus
                />
                <Button variant="dark" onClick={handleAddOrder}>
                    Add
                </Button>
            </Form.Group>

            {orders.length > 0 && (
                <>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Order ID</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((item, index) => (
                                <tr key={item}>
                                    <td>{index + 1}</td>
                                    <td>{item}</td>
                                    <td className="text-center">
                                        <FaTrash
                                            style={{ cursor: "pointer", color: "red" }}
                                            onClick={() => handleRemove(item)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <Form.Group className="mb-3">
                        <Form.Label>Select Status For All</Form.Label>
                        <Form.Select
                            value={bulkStatus}
                            onChange={(e) => setBulkStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="returned">Returned</option>
                            <option value="delivered">Delivered</option>
                        </Form.Select>
                    </Form.Group>

                    <Button
                        variant="success"
                        onClick={handleBulkUpdate}
                        disabled={!bulkStatus || loading}
                    >
                        {loading ? "Updating..." : "Update All"}
                    </Button>
                </>
            )}
        </div>
    );
};

export default BulkUpdate;